<script>
import axios from 'axios'
import PQueue from 'p-queue'

const BASE_URL = process.env.NODE_ENV === 'development'
    ? 'http://localhost:11100/'
    : location.origin

export default {
  data() {
    return {
      client: null,
      queue: null
    }
  },

  methods: {
    /**
     * Get token from URL parameters
     * @return {string}
     */
    getTokenFromUrl() {
      const urlParams = new URLSearchParams(window.location.search)
      return urlParams.get('token') || ''
    },

    /**
     * Set Axios client connection to the server side
     * @return {void}
     */
    setClient () {
      const token = this.getTokenFromUrl()

      this.client = axios.create({
        baseURL: BASE_URL
      })

      this.client.interceptors.request.use(config => {
        // Add token to URL params if not already present
        if (token && !config.params) {
          config.params = { token }
        } else if (token) {
          config.params = { ...config.params, token }
        }

        return config
      })
    }
  },

  created() {
    this.setClient()
    this.queue = new PQueue({concurrency: 1})
  }
}
</script>
